export interface Feature {
  title: string
  individual: boolean
  business: boolean
  enterprise: boolean
  label?: string
  footnote?: string
}

export interface FeatureGroup {
  title: string
  features: Feature[]
}

// Set type as array of Feature
const chatFeatures: Feature[] = [
  {
    title: 'Unlimited messages and interactions',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Context-aware coding support and explanations',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Debugging and security remediation assistance',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Access to knowledge from top open source repositories²',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Pull request diff analysis²',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Web search powered by Bing (Public Beta)',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Ability to ask about a failed Actions jobs (Public Beta)',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Answers about issues, PRs, discussions, files, commits etc.²',
    individual: true,
    business: true,
    enterprise: true,
  },
]

const codeCompletionFeatures: Feature[] = [
  {
    title: 'Real time code suggestions',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Comments to code',
    individual: true,
    business: true,
    enterprise: true,
  },
]

const customizationFeatures: Feature[] = [
  {
    title: 'Tailor chat conversations to your private codebase (up to 5/50/unlimited repos)²',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Unlimited integrations with Copilot Extensions (Public Beta)',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Build a private extension for internal tooling (Public Beta)',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Attach knowledge bases to chat for organizational context',
    individual: false,
    business: false,
    enterprise: true,
  },
  {
    title: 'Fine-tuned models for code completion (coming soon as add-on)',
    individual: false,
    business: false,
    enterprise: true,
  },
]

const aiNativeExperiencesFeatures: Feature[] = [
  {
    title: 'Inline chat and prompt suggestions',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Slash commands and context variables',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Commit message generation',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'Pull request summary generation²',
    individual: true,
    business: true,
    enterprise: true,
  },
]

const devEnvFeatures: Feature[] = [
  {
    title: 'IDE, CLI and GitHub Mobile',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'GitHub.com²',
    individual: true,
    business: true,
    enterprise: true,
  },
]

const managementPoliciesFeatures: Feature[] = [
  {
    title: 'Public code filter with code referencing',
    individual: true,
    business: true,
    enterprise: true,
  },
  {
    title: 'User management',
    individual: false,
    business: true,
    enterprise: true,
  },
  {
    title: 'Data excluded from training by default',
    individual: false,
    business: true,
    enterprise: true,
  },
  {
    title: 'Enterprise-grade security',
    individual: false,
    business: true,
    enterprise: true,
  },
  {
    title: 'IP indemnity',
    individual: false,
    business: true,
    enterprise: true,
  },
  {
    title: 'Content exclusions',
    individual: false,
    business: true,
    enterprise: true,
  },
  {
    title: 'SAML SSO authentication¹',
    individual: false,
    business: true,
    enterprise: true,
  },
  {
    title: 'Requires GitHub Enterprise Cloud',
    individual: false,
    business: false,
    enterprise: true,
  },
  {
    title: 'Usage metrics',
    individual: false,
    business: true,
    enterprise: true,
  },
]

export const allFeaturesOld: FeatureGroup[] = [
  {
    title: 'Chat',
    features: chatFeatures,
  },
  {
    title: 'Code completion',
    features: codeCompletionFeatures,
  },
  {
    title: 'Customization',
    features: customizationFeatures,
  },
  {
    title: 'AI-native experiences',
    features: aiNativeExperiencesFeatures,
  },
  {
    title: 'Supported environments',
    features: devEnvFeatures,
  },
  {
    title: 'Management and policies',
    features: managementPoliciesFeatures,
  },
]
